<template>
  <div v-if="open" class="netstate" role="dialog" aria-modal="true" :aria-label="title">
    <div class="nbody"><slot></slot></div>
    <div class="nfoot"><slot name="foot"></slot></div>
  </div>
</template>

<script>
/**
 * Full-screen, non-destructive state overlay — used for the connectivity error and the
 * resume prompt.
 *
 * It covers the screen rather than dimming it because both cases block the flow entirely,
 * and neither discards anything: whatever the user has captured is still there behind it.
 */
export default {
  name: "StateOverlay",

  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "" },
  },
};
</script>

<style scoped>
.netstate {
  position: absolute;
  inset: 0;
  z-index: 50;
  background: var(--background);
  display: flex;
  flex-direction: column;
  padding: 24px 22px calc(20px + env(safe-area-inset-bottom));
}

.nbody {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
}

.nbody >>> h2 {
  margin-top: 10px;
}

.nfoot {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
